const AuthServices = {
  LOGIN: 'core/authentication/login/',
  GENERATE: 'core/authentication/token/generate',
  REFRESH: 'core/authentication/token/refresh',
  OTT: 'core/authentication/ott',
};

const AuthServiceMethods = {
  GENERATE: 'GenerateToken',
  REFRESH: 'RefreshToken',
  GENERATE_OTT: 'GenerateOTT',
};

const TimeoutLabels = {
  REFRESH_TOKEN: 'TIMEOUT:REFRESH_TOKEN',
  INVALIDATE_TOKEN: 'TIMEOUT:INVALIDATE_TOKEN',
};

module.exports = {
  AuthServices,
  AuthServiceMethods,
  TimeoutLabels,
};
